<div class="modal-header">
  <h4 class="modal-title">
    @if (accessDoorGroupType) {
      Editar grupo de puerta de acceso {{ accessDoorGroupType.accessDoorGroupTypeId }} 
    }

    @if (!accessDoorGroupType) {
      Nuevo grupo de puerta de acceso
    }
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if (!loading) {
    <form
      id="formAccessDoorGroupType"
      [formGroup]="formAccessDoorGroupType"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          @if(imageBase64 || (accessDoorGroupType && accessDoorGroupType.image)) {
            <div class="col-12">
              <img [src]="imageBase64 ? imageBase64 : (accessDoorGroupType && accessDoorGroupType!.image) ? accessDoorGroupType.image.urlFile : ''" width="100%">
            </div>
          }

          @for (key of utilService.objectKeys(dataForm); track key) {
            @if (
              dataForm[key].type != "select" &&
              dataForm[key].type != "switch" &&
              dataForm[key].type != "image" &&
              dataForm[key].type != "textarea"
            ) {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input
                  [type]="dataForm[key].type"
                  class="form-control"
                  formControlName="{{ key }}"
                  [placeholder]="dataForm[key].placeholder ?? dataForm[key].label"
                  [ngClass]="{
                    'is-invalid': submitted && f[key].errors
                  }">
                  @if (submitted && f[key].errors && dataForm[key].required) {
                    <div class="invalid-feedback">
                      @if (f[key].errors!['required']) {
                        <div>{{ dataForm[key].requiredMessage }}</div>
                      }
                    </div>
                  }
              </div>
            }

            @if(dataForm[key].type == 'image') {
              <div class="col-12 form-group mb-4">
                <label [htmlFor]="key" class="form-label">
                  {{ dataForm[key].label }}
                </label>
                <input 
                  class="form-control" 
                  type="file" 
                  accept="image/*"
                  [id]="key"
                  (change)="onFileChange($event)">
              </div>
            }

          }

        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formAccessDoorGroupType"
      class="btn btn-primary w-100">
      {{ accessDoorGroupType ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
